import React, { useEffect, useState } from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { MenuIcon, XIcon, BookOpenIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Servicios',
    href: '#beneficios'
  }, {
    name: 'Proceso',
    href: '#como-funciona'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-104">
      <Container data-id="element-105">
        <div className="flex items-center justify-between" data-id="element-106">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-107">
            <div className="bg-brand-navy-900 p-2 rounded-lg text-white group-hover:bg-brand-amber-500 transition-colors" data-id="element-108">
              <BookOpenIcon size={24} data-id="element-109" />
            </div>
            <div className="flex flex-col" data-id="element-110">
              <span className="text-xl font-bold text-brand-navy-900 leading-none" data-id="element-111">
                TGT FLIP
              </span>
              <span className="text-xs font-medium text-brand-navy-700 tracking-wider" data-id="element-112">
                RECURSOS EDUCATIVOS
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-113">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-navy-700 hover:text-brand-amber-600 transition-colors" data-id="element-114">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-brand-navy-900" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-115">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-116" /> : <MenuIcon size={24} data-id="element-117" />}
          </button>
        </div>
      </Container>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-118">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-119">
            <Container className="py-6 flex flex-col gap-4" data-id="element-120">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-brand-navy-700 py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-121">
                  {link.name}
                </a>)}
            </Container>
          </motion.div>}
      </AnimatePresence>
    </header>;
}